module.exports = __webpack_public_path__ + "img/report-task.4ce6cfa1.svg";